export const tr = {
    auto: 'Oto',
    'bid-auto-strategy-info':
        'Teklif, otomatik strateji koşulları göz önüne alınarak hesaplanır. Otomatik teklif yönetim stratejileri etkinken, reklam gösterimleri sistem tarafından yönetilir.'
};
